var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.menuVisible),expression:"menuVisible"}],staticClass:"contextmenu",style:(_vm.menuStyle)},[_vm._t("menuList")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }